import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MDTypography from "components/MDTypography";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import { useAuth } from "context";
import { NoDataPage } from "examples/Widgets/NoDataPage";
import Tooltip from "@mui/material/Tooltip";
import tooltipIcon from "../../../assets/images/icons/catering-icons/tooltip-icon.svg";
import formatNumberWithCommas from "../../../core/utils/formatNumberWithCommas";
import { RemoveRedEye, ContentCopy } from "@mui/icons-material";
import { Modal } from "@mui/material";
import { getDecryptedClaimCode } from "../_request";
import MDButton from "components/MDButton";
import Divider from "@mui/material/Divider";
function Row({ data, setRefreshData }) {
  const [open, setOpen] = React.useState(false);
  const [claimCodeVisibility, setClaimCodeVisibility] = React.useState({});
  const { darkMode } = useAuth();
  const [openModal, setOpenModal] = React.useState(false);
  const [openClaimCodeModal, setOpenClaimCodeModal] = React.useState(false);
  const [copied, setCopied] = React.useState(false);

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => setOpenModal(false);

  const handleCloseForClaimCode = () => {
    window.location.href = "https://www.amazon.com/gc/redeem";
    setRefreshData(true);
  };

  const handleClaimCodeModalClose = () => {
    setOpenClaimCodeModal(false);
    setRefreshData(true); // Add refresh here too
  };

  const handleConfirm = async (giftCardId, id) => {
    const {
      data: { success, data: response },
    } = await getDecryptedClaimCode(id);
    if (success) {
      data["decryptedClaimCode"] = response;
      setOpenClaimCodeModal(true);
    }
    handleClose();
  };

  const toggleClaimCode = (giftCardId) => {
    const giftCardIdValue = typeof giftCardId === "object" ? giftCardId.props.children : giftCardId;
    setClaimCodeVisibility((prev) => ({
      ...prev,
      [giftCardIdValue]: !prev[giftCardIdValue],
    }));
  };

  const isCodeViewed = data?.claimCodeViewed;
  const codeViewedDate = data?.claimCodeViewedOn ? new Date(data.claimCodeViewedOn) : null;

  return (
    <>
      <TableRow>
        <TableCell
          align="left"
          scope="row"
          data-label="GIFT CARD ID"
          sx={{ color: darkMode ? "white !important" : "" }}
        >
          {data?.giftCardId}
        </TableCell>
        <TableCell
          align="center"
          data-label="POINTS"
          sx={{ color: darkMode ? "white !important" : "" }}
        >
          {data?.points}
        </TableCell>
        <TableCell
          align="center"
          data-label="REDEMPTION DATE"
          sx={{ color: darkMode ? "white !important" : "" }}
        >
          {data?.redemptionDate}
        </TableCell>
        <TableCell
          align="center"
          data-label="AMOUNT"
          sx={{ color: darkMode ? "white !important" : "" }}
        >
          {data?.amount}
        </TableCell>
        <TableCell
          align="center"
          data-label="NUMBER OF ORDERS"
          sx={{ color: darkMode ? "white !important" : "" }}
        >
          {data?.orderNumber}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            display: "flex",
            justifyContent: "center",
            color: darkMode ? "white !important" : "",
          }}
          data-label="REDEMPTION STATUS"
        >
          {data?.redemptionStatus}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            justifyContent: "center",
            color: darkMode ? "white !important" : "",
          }}
          data-label="AMAZON CLAIM CODE"
        >
          <>
            {data?.giftCardId?.props?.children !== "-" && !data?.claimCodeViewed ? (
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                {claimCodeVisibility[data?.giftCardId.props.children] ? (
                  data?.decryptedClaimCode
                ) : data?.claimCode.props.children === "" ||
                  data?.claimCode.props.children === null ? (
                  "-"
                ) : (
                  <MDTypography
                    component="a"
                    href="#"
                    variant="caption"
                    color="success"
                    fontWeight="medium"
                    onClick={() => {
                      if (!claimCodeVisibility[data?.giftCardId?.props?.children]) {
                        handleOpen(data?.giftCardId);
                      } else {
                        toggleClaimCode(data?.giftCardId?.props?.children);
                      }
                    }}
                  >
                    View Code
                  </MDTypography>
                )}
              </MDTypography>
            ) : isCodeViewed && codeViewedDate ? (
              <Tooltip
                title="You have already viewed this claim code. For security, it cannot be viewed again, but you should have it on your email."
                placement="top"
              >
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="text"
                  fontWeight="medium"
                >
                  {`Viewed on ${codeViewedDate.toDateString()}`}
                </MDTypography>
              </Tooltip>
            ) : (
              "-"
            )}
          </>
        </TableCell>

        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? (
              <KeyboardArrowUpIcon color={darkMode ? "white" : ""} />
            ) : (
              <KeyboardArrowDownIcon color={darkMode ? "white" : ""} />
            )}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit sx={{ width: "100%" }}>
            {data?.restaurantData && !!data?.restaurantData?.length && (
              <Box
                sx={{
                  margin: 1,
                  backgroundColor: !darkMode ? "#EAEFF2" : "#546272",
                  borderRadius: "0.75rem",
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  component="div"
                  fontWeight={"regular"}
                  px={1.8}
                  pt={2}
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                  }}
                >
                  Associated Orders
                </Typography>
                <Table
                  size="small"
                  aria-label="purchases"
                  className="custom-table-project dropdown-table"
                >
                  <TableHead sx={{ display: "contents" }}>
                    <TableRow
                      sx={{
                        "& > *": {
                          paddingLeft: "1rem",
                          paddingTop: "0",
                          paddingBottom: "0",
                        },
                      }}
                    >
                      <DataTableHeadCell sorted={false}>RESTAURANT NAME</DataTableHeadCell>
                      <DataTableHeadCell sorted={false}>Order ID</DataTableHeadCell>
                      <DataTableHeadCell sorted={false} align="center">
                        SUBTOTAL AMOUNT
                      </DataTableHeadCell>
                      <DataTableHeadCell sorted={false} align="center">
                        CASHBACK POINTS
                      </DataTableHeadCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.restaurantData?.map((historyRow) => (
                      <TableRow
                        key={historyRow.date}
                        sx={{
                          "& > *": {
                            paddingLeft: "1rem",
                            paddingBottom: "4px",
                            paddingTop: "0",
                          },
                        }}
                      >
                        <TableCell
                          p={0}
                          data-label="RESTAURANT NAME"
                          sx={{ color: darkMode ? "white !important" : "" }}
                        >
                          {historyRow.restaurantName}
                        </TableCell>
                        <TableCell
                          scope="row"
                          data-label="Order ID"
                          sx={{ color: darkMode ? "white !important" : "" }}
                        >
                          {historyRow.orderID}
                        </TableCell>

                        <TableCell
                          p={0}
                          align="center"
                          data-label="SUBTOTAL AMOUNT"
                          sx={{ color: darkMode ? "white !important" : "" }}
                        >
                          {historyRow?.subTotalInCents || "0"}
                        </TableCell>
                        <TableCell
                          p={0}
                          align="center"
                          data-label="CASHBACK POINTS"
                          sx={{ color: darkMode ? "white !important" : "" }}
                        >
                          {historyRow?.cashbackPoints || "0"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
            {data?.additionalPoints && !!data?.additionalPoints.length && (
              <Box
                sx={{
                  margin: 1,
                  backgroundColor: !darkMode ? "#EAEFF2" : "#546272",
                  borderRadius: "0.75rem",
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  component="div"
                  fontWeight={"regular"}
                  px={1.8}
                  pt={2}
                >
                  Associated additional Points
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead sx={{ display: "contents" }}>
                    <TableRow
                      sx={{
                        "& > *": {
                          paddingLeft: "1rem",
                          paddingTop: "0",
                          paddingBottom: "0",
                        },
                      }}
                    >
                      <DataTableHeadCell sorted={false}>Restaurant Name</DataTableHeadCell>
                      <DataTableHeadCell sorted={false} align="center">
                        Cashback Points
                      </DataTableHeadCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.additionalPoints?.map((historyRow) => (
                      <TableRow
                        key={historyRow.id}
                        sx={{
                          "& > *": {
                            paddingLeft: "1rem",
                            paddingBottom: "4px",
                            paddingTop: "0",
                          },
                        }}
                      >
                        <TableCell component="th" scope="row" p={0} width={"50%"}>
                          {historyRow.restaurantName}
                        </TableCell>
                        <TableCell p={0} align="center">
                          {historyRow?.cashBackPoints}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
          </Collapse>
        </TableCell>
      </TableRow>
      <Modal open={openModal} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            variant: "gradient",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <MDTypography fontWeight="light" color="text" sx={{ fontSize: "14px", mt: 2 }}>
            You will only be able to view this claim code once. Are you sure you want to proceed?
          </MDTypography>
          <Box mt={2} display="flex" justifyContent="space-between">
            <MDButton variant="outlined" color={"success"} size="medium" onClick={handleClose}>
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              color={"success"}
              size="medium"
              sx={{ marginLeft: 2 }}
              onClick={() => handleConfirm(data?.giftCardId.props.children, data.giftCardNo)}
            >
              Proceed
            </MDButton>
          </Box>
        </Box>
      </Modal>
      <Modal open={openClaimCodeModal} hideBackdrop={false}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            variant: "gradient",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 420,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2.5,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          {/* close icon/button  */}
          <IconButton
            aria-label="close"
            onClick={handleClaimCodeModalClose}
            sx={{ position: "absolute", right: 9, top: 10 }}
          >
            <CloseIcon sx={{ width: 22, height: 22 }} />
          </IconButton>

          <div style={{ fontSize: "18px", fontWeight: 600, color: "#181D27", textAlign: "left" }}>
            Amazon Claim Code
          </div>
          <p
            style={{
              fontSize: "14px",
              marginTop: 8,
              fontWeight: 400,
              lineHeight: "20px",
              color: "#535862",
              textAlign: "left",
            }}
          >
            This is your only time to view your claim code. Once you close this popup, it will
            disappear. A copy has been sent to{" "}
            {data?.redemptionEmail ? (
              <strong>{data?.redemptionEmail}</strong>
            ) : (
              "your registered email"
            )}
            . Save it securely.
          </p>
          <Divider />
          <p className="text-sm font-medium text-left text-[#414651] mt-2">Amazon Claim Code</p>
          <Box mt={1} mb={3} sx={{ display: "flex" }}>
            <MDTypography variant="div" sx={{ width: "100%" }}>
              <input
                type="text"
                value={data?.decryptedClaimCode}
                readOnly
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "10px",
                  border: "1px solid #ccc",
                  fontSize: "14px",
                }}
              />
            </MDTypography>
            <MDTypography>
              <Tooltip title={copied ? "Copied!" : "Copy to clipboard"} arrow>
                <ContentCopy
                  sx={{ ml: 2, cursor: "pointer", mt: 1 }}
                  onClick={() => {
                    if (data?.decryptedClaimCode) {
                      navigator.clipboard.writeText(data.decryptedClaimCode);
                      setCopied(true);
                      setTimeout(() => setCopied(false), 2000);
                    } else {
                      console.error("decryptedClaimCode is undefined");
                    }
                  }}
                  color={darkMode ? "white" : ""}
                />
              </Tooltip>
            </MDTypography>
          </Box>
          <Box mt={5} display="flex" justifyContent="center" sx={{ width: "100%" }}>
            <MDButton
              variant="gradient"
              color={"success"}
              size="md"
              sx={{
                borderRadius: "6px",
                gap: (theme) => theme.spacing(5), // Adjust as needed
                paddingTop: "10px",
                paddingBottom: "10px",
                borderWidth: "2px",
                width: "100%",
                textTranform: "capitalize",
              }}
              onClick={() => handleCloseForClaimCode()}
            >
              Redeem Claim Code on Amazon
            </MDButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
export default function CollapsibleTable({ redeemData, setRefreshData }) {
  let rows = [];

  if (redeemData && redeemData.length > 0) {
    rows = redeemData.map((data) => {
      const restaurantRows =
        data.orders?.map((historyRow) => {
          return {
            orderID: (
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                {historyRow.orderId}
              </MDTypography>
            ),
            restaurantName: (
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                {historyRow?.restaurantName}
              </MDTypography>
            ),
            subTotalInCents: (
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                {"$"}
                {formatNumberWithCommas(historyRow.subtotalAmount / 100)}
              </MDTypography>
            ),
            cashbackPoints: (
              <MDBox
                sx={{ display: "flex", gap: 1, alignItems: "center", justifyContent: "center" }}
              >
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="text"
                  fontWeight="medium"
                >
                  {historyRow.cashbackPoints}
                </MDTypography>
                {historyRow.campaignPoints && (
                  <>
                    <MDTypography
                      component="a"
                      href="#"
                      variant="caption"
                      color="text"
                      fontWeight="medium"
                    >
                      {historyRow.campaignPoints ? ` + ${historyRow.campaignPoints}` : null}
                    </MDTypography>
                    <Tooltip
                      key={"maxCashback"}
                      title={
                        <div style={{ textAlign: "left" }}>
                          {" "}
                          {"Extra points earned through the campaign "}
                          {`"${historyRow?.campaignName}"`}
                          {" campaign"}
                        </div>
                      }
                    >
                      <MDAvatar
                        src={tooltipIcon}
                        name={"campaignCashback"}
                        size="sm"
                        sx={{ width: 15, height: 15 }}
                      />
                    </Tooltip>
                  </>
                )}

                {historyRow.nsuPoints && (
                  <>
                    <MDTypography
                      component="a"
                      href="#"
                      variant="caption"
                      color="text"
                      fontWeight="medium"
                    >
                      {historyRow.nsuPoints ? ` + ${historyRow.nsuPoints}` : null}
                    </MDTypography>{" "}
                    <Tooltip
                      key={"maxCashback"}
                      title={<div style={{ textAlign: "left" }}>Sign up bonus Points</div>}
                    >
                      <MDAvatar
                        src={tooltipIcon}
                        name={"nsuCashback"}
                        size="sm"
                        sx={{ width: 15, height: 15 }}
                      />
                    </Tooltip>
                  </>
                )}
              </MDBox>
            ),
          };
        }) || [];

      const addtionalPointRows =
        data.additionalPoints?.map((historyRow) => {
          return {
            restaurantName: (
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                {historyRow?.restaurantName}
              </MDTypography>
            ),
            cashBackPoints: (
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                {historyRow?.cashbackPoints || 0}
              </MDTypography>
            ),
          };
        }) || [];
      return {
        redemptionDate: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data.giftCard
              ? data.giftCard.createdAt && new Date(data.giftCard.createdAt).toDateString()
              : "-"}
          </MDTypography>
        ),
        points: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data?.giftCard ? data?.giftCard.amountInCents : data.totalPoints}
          </MDTypography>
        ),
        giftCardId: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data?.giftCard ? data.giftCard.creationRequestId : "-"}
          </MDTypography>
        ),
        claimCode: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data?.giftCard ? data.giftCard.claimCode : "-"}
          </MDTypography>
        ),
        redemptionStatus: (
          <MDBox width="84px">
            <MDBox
              sx={{
                backgroundColor: data?.status === "PENDING" ? "#FFD700" : "#238856",
                borderRadius: "4px",
                padding: "5px",
                position: "relative",
              }}
            >
              <MDBox
                sx={{
                  color: "#FFFFFF",
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1,
                }}
              >
                {data?.status}
              </MDBox>
            </MDBox>
          </MDBox>
        ),
        amount: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {"$"}
            {data?.giftCard
              ? (data.giftCard.amountInCents / 100)?.toFixed(2)
              : (data.totalPoints / 100)?.toFixed(2)}
          </MDTypography>
        ),
        orderNumber: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data.orders?.length}
          </MDTypography>
        ),
        giftCardNo: data?.giftCard?.id,
        claimCodeViewed: data?.giftCard?._giftcard_giftcard_logs ? 1 : 0,
        claimCodeViewedOn: data?.giftCard?._giftcard_giftcard_logs?.timestamp,
        restaurantData: restaurantRows,
        additionalPoints: addtionalPointRows,
        redemptionEmail: data?.giftCard?.email,
      };
    });
  }
  const tableBody = rows.length > 0 && (
    <TableBody>
      {rows.map((data, index) => (
        <Row key={index} data={data} setRefreshData={setRefreshData} />
      ))}
    </TableBody>
  );
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table" className="custom-table-project">
        <TableHead sx={{ display: "contents" }}>
          <TableRow>
            <DataTableHeadCell sorted={false}>GIFT CARD ID</DataTableHeadCell>
            <DataTableHeadCell sorted={false} align="center">
              POINTS
            </DataTableHeadCell>
            <DataTableHeadCell sorted={false} align="center">
              REDEMPTION DATE
            </DataTableHeadCell>
            <DataTableHeadCell sorted={false} align="center">
              AMOUNT
            </DataTableHeadCell>
            <DataTableHeadCell sorted={false} align="center">
              NUMBER OF ORDERS
            </DataTableHeadCell>
            <DataTableHeadCell sorted={false} align="center">
              REDEMPTION STATUS
            </DataTableHeadCell>
            <DataTableHeadCell sorted={false} align="center">
              <Tooltip
                key="claim-code-info"
                title={
                  <div style={{ textAlign: "center" }}>
                    Your Amazon Gift Card claim code is a unique code to add the card&apos;s balance
                    to your account. Just enter it on the &quot;Redeem a Gift Card&quot; page, and
                    the amount will be available for your purchases.
                  </div>
                }
                placement="bottom"
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  AMAZON CLAIM CODE
                  <MDAvatar
                    src={tooltipIcon}
                    name="claim-code-info"
                    size="sm"
                    sx={{ width: 15, height: 15 }}
                  />
                </span>
              </Tooltip>
            </DataTableHeadCell>

            <DataTableHeadCell sorted={false} />
          </TableRow>
        </TableHead>
        {tableBody && tableBody}
      </Table>
      {rows.length === 0 && <NoDataPage />}
    </TableContainer>
  );
}

CollapsibleTable.propTypes = {
  redeemData: PropTypes.any,
  refreshTable: PropTypes.bool,
  setRefreshData: PropTypes.any,
};

Row.propTypes = {
  data: PropTypes.shape({
    giftCardId: PropTypes.node.isRequired,
    points: PropTypes.node.isRequired,
    redemptionDate: PropTypes.node.isRequired,
    amount: PropTypes.node.isRequired,
    redemptionStatus: PropTypes.node.isRequired,
    orderNumber: PropTypes.node.isRequired,
    claimCode: PropTypes.node,
    decryptedClaimCode: PropTypes.node,
    claimCodeViewed: PropTypes.node,
    giftCardNo: PropTypes.node,
    claimCodeViewedOn: PropTypes.node,
    redemptionEmail: PropTypes.node,
    restaurantData: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.node.isRequired,
        orderID: PropTypes.node.isRequired,
        subTotalInCents: PropTypes.node.isRequired,
        cashbackPoints: PropTypes.node.isRequired,
      })
    ),
    additionalPoints: PropTypes.arrayOf(
      PropTypes.shape({
        restaurantName: PropTypes.node.isRequired,
        cashbackPoints: PropTypes.node.isRequired,
      })
    ),
  }).isRequired,
  setRefreshData: PropTypes.node,
};
